import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "modal-wrapper" }
const _hoisted_2 = { class: "description" }
const _hoisted_3 = { class: "bold" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock($setup["Modal"], {
    isOpen: $props.isOpen,
    onClose: $setup.close
  }, {
    content: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _cache[0] || (_cache[0] = _createElementVNode("div", { class: "modal-title" }, "Transfer Ownership", -1)),
        _createElementVNode("div", _hoisted_2, [
          _createTextVNode("Lot " + _toDisplayString($props.lot.title) + " is currently owned by", 1),
          _createElementVNode("span", _hoisted_3, " " + _toDisplayString($setup.lotOwnership) + ". ", 1),
          _createTextVNode("Are you sure you would like to transfer ownership to " + _toDisplayString($setup.newOwnership) + "?", 1)
        ]),
        _createElementVNode("div", { class: "controls" }, [
          _createElementVNode("button", {
            class: "button modal cancel",
            onClick: $setup.close
          }, "Cancel"),
          _createElementVNode("button", {
            class: "button modal primary proceed",
            onClick: $setup.proceed
          }, "Transfer")
        ])
      ])
    ]),
    _: 1
  }, 8, ["isOpen"]))
}